// `/search?q=` — the query lives in the URL, like every other list screen here.
//
// So a result set is a link somebody can send, a back button returns to the
// search rather than to the box, and a reload does not lose the question.

export interface SearchPageSearch {
  q: string;
}

/** Never throws: a malformed URL becomes an empty search, not a crash. */
export function validateSearchPageSearch(raw: Record<string, unknown>): SearchPageSearch {
  const q = typeof raw["q"] === "string" ? raw["q"] : "";
  return { q };
}
